import { useEffect } from 'react';
import Loading from './Loading';
import fetchWithToken from '../services';

const StripeOnboarding = () => {
  useEffect(() => {
    const redirectToStripe = async () => {
      try {
        const response = await fetchWithToken('/create-stripe-onboarding-link', {
            method: 'POST'
        });
        const data = await response.json();
        const url = data.accountLink.url;
        console.log(url);
        window.location.href = url; // Redirect to Stripe
      } catch (error) {
        console.error('Error generating Stripe onboarding link:', error);
      }
    };

    redirectToStripe();
  }, []);

  return <Loading />; // No need to render anything
};

export default StripeOnboarding;
